import { Users } from "lucide-react";

const PlayerRows = ({ players, testid }) => (
  <ol className="space-y-1" data-testid={testid}>
    {players.map((p) => (
      <li key={p.n} className="flex items-center gap-2 text-sm text-[#333333]">
        <span className="w-6 shrink-0 text-right font-semibold text-[#999999] tabular-nums">{p.n}.</span>
        <span className="min-w-0 break-words">{p.name}</span>
        {p.fargo && (
          <span className="ml-auto shrink-0 rounded-full bg-[#1E63C4]/10 text-[#1E63C4] px-2 py-0.5 text-[11px] font-semibold tabular-nums">Fargo {p.fargo}</span>
        )}
      </li>
    ))}
  </ol>
);

// Auto-built list from registrations: one numbered list, or one per division.
export function TournamentPlayerList({ groups, testid }) {
  const total = groups.reduce((n, g) => n + g.players.length, 0);
  const grouped = !(groups.length === 1 && groups[0].division === "");
  return (
    <div data-testid={testid}>
      <p className="text-xs font-semibold uppercase tracking-wide text-[#1E63C4] mb-2 inline-flex items-center gap-1.5">
        <Users className="h-3.5 w-3.5" /> Registered Players
        <span className="text-[#999999]" data-testid={`${testid}-total`}>({total})</span>
      </p>
      {!grouped ? (
        <PlayerRows players={groups[0].players} testid={`${testid}-rows`} />
      ) : (
        <div className="space-y-3">
          {groups.map((g) => (
            <div key={g.division || "none"} data-testid={`${testid}-group-${g.division || "none"}`}>
              <p className="text-sm font-bold text-[#111111] mb-1">
                {g.division || "Division not chosen"} <span className="font-normal text-[#999999]" data-testid={`${testid}-count-${g.division || "none"}`}>· {g.players.length}{g.max_players ? ` / ${g.max_players}` : ""}</span>
              </p>
              {g.players.length ? (
                <PlayerRows players={g.players} testid={`${testid}-rows-${g.division || "none"}`} />
              ) : (
                <p className="text-xs text-[#999999]">No players yet.</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
